import Title from "../../Title"

const Processing = () => (
  <div
    css={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "start",
      flex: 1,
    }}
  >
    <Title title="Processing video..." />

    <p
      css={{
        margin: 0,
        color: "#F2F3F5",
        fontSize: 17,
        textAlign: "center",
      }}
    >
      We promise it’s worth the wait!
    </p>
    {/* {showEmailModule && <div>
        <p
          css={{
            color: 'rgba(110, 110, 110, 1)',
            fontSize: '15px',

          }}
        >
          In a hurry? Leave your email and we'll send you a link when it's ready.
        </p>
      </div>} */}
  </div>
)

export default Processing
